import { createContext } from 'react';

export const GradientContext = createContext(null);
export const ContactContext = createContext(null);
export const BackgroundContext = createContext(null);
export const ZoomLevelContext = createContext(null);
export const AnimationsActiveContext = createContext(null);
